import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUser } from "../../modules/user/model/user";

interface IAuthState {
  user: Partial<IUser> | undefined;
}

const initialState: IAuthState = {
  user: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<Partial<IUser>>) => {
      state.user = action.payload;
    },
  },
});

export const { setUser } = authSlice.actions;

export default authSlice.reducer;
